module.exports = __webpack_public_path__ + "img/login.347814a1.svg";